"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var ParagraphModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_simplemde_1 = __importDefault(require("vue-simplemde"));
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `Heading`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ParagraphModuleForm = ParagraphModuleForm_1 = class ParagraphModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = ParagraphModuleForm_1.getInitialContent();
        this.text = '';
    }
    mounted() {
        this.text = this.paragraph;
    }
    /**
     * Paragraph parsed from tag <br>
     */
    get paragraph() {
        return this._content.text.replace(/<br\s*[/]?>/gi, '\n');
    }
    /**
     * Paragraph parsed with tag <br>
     */
    set paragraph(value) {
        this._content.text = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    onModelChange(text) {
        this.paragraph = text;
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Paragraph,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: true
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            text: ''
        };
    }
};
__decorate([
    vue_property_decorator_1.Watch('text'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ParagraphModuleForm.prototype, "onModelChange", null);
ParagraphModuleForm = ParagraphModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'ParagraphModuleForm',
        components: { VueSimpleMDE: vue_simplemde_1.default, FormErrors: form_2.FormErrors },
        template: `
    <div>
      <div class="form-group">
        <label for="text">{{ $t('forms.paragraph.content') }}</label>
        <VueSimpleMDE name="text" v-model="text" />
      </div>

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], ParagraphModuleForm);
exports.ParagraphModuleForm = ParagraphModuleForm;
//# sourceMappingURL=Paragraph.form.js.map